"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InputValidationState;
(function (InputValidationState) {
    InputValidationState[InputValidationState["unset"] = 0] = "unset";
    InputValidationState[InputValidationState["invalid"] = 1] = "invalid";
    InputValidationState[InputValidationState["valid"] = 2] = "valid";
})(InputValidationState = exports.InputValidationState || (exports.InputValidationState = {}));
//# sourceMappingURL=InputValidationState.js.map